export default {
    attribute: {
        cptTableData:[
            {"name":"显示文本","value":"","namekey":"label"},
            {"name":"值","value":"","namekey":"value"},
        ],
        label: '选项：',
        labelAlign:'right',
        size:'medium',
        width:20,
        height:20,
        borderRadius:0,
        bgColor:'rgba(0, 0, 0, 0)',
        brColor:'#fff',
        activeBgColor: 'rgba(38, 132, 255, 0)',
        activeBrColor: '#2684ff',
        activeBg:'#fff',
        activeColor: '#2684ff',
        textColor:'#ffffff',
        fontStyle:'normal',
        fontWeight:'normal',
        fontFamily:'微软雅黑',
        fontSize:12,
        required:false,
        panelBg:'#00000000',
        disableColor:'#ffffff',
        disableBg:'#00000000',
        bg:'#00000000',
        panelNum:'',
        activeNum: '',
        activeNum: '',
        disableBool:false,
        disableBool:false,
        bgBool:false,
    },
    interaction: {
        eventText: '勾选时'
    },
    cptDataForm: {
        dataText: '{"value":["op1","op2"],"options":[{"label":"选项1","value":"op1"},{"label":"选项2","value":"op2"},{"label":"选项3","value":"op3"}]}',
        apiUrl: '/select',
        sql: 'select id from test limit 1',
        dataSource: 1,
        pollTime: -1
    }
}